import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Typography, Box } from "@mui/material";
import {
  MiniAboutUs,
  MiniNavbar,
  MiniOffice,
  MiniContactUs,
} from "./MiniFooter";

const useStyles = makeStyles((theme) => ({
  footer: {
    width: "100%",
    maxWidth: 1200,
    margin: "0 auto",
    padding: theme.spacing(2, 2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
  },
  bottomRow: {
    padding: theme.spacing(1, 3),
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
      alignItems: "center",
    },
  },
  copyright: {
    fontSize: "0.875rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <Box component="footer" className={classes.footer}>
      <Grid container spacing={2}>
        {/* On extra-small screens each item is full width,
            on small screens two items per row,
            on medium and up four items per row */}
        <Grid item xs={12} sm={6} md={3}>
          <MiniAboutUs />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MiniNavbar />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MiniOffice />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <MiniContactUs />
        </Grid>
      </Grid>
      <Box className={classes.bottomRow} mt={3}>
        <Typography className={classes.copyright}>
          &copy; 2024 RaSynth LLP
        </Typography>
        <Typography className={classes.copyright}>Privacy Policy</Typography>
      </Box>
    </Box>
  );
};

export default Footer;
